(() => {
  if (window.vininvestorenSubscribeButtonsInitialized) return;
  window.vininvestorenSubscribeButtonsInitialized = true;

  const updateButton = (button) => {
    const checkoutURL = new URL(button.dataset.subscribeCheckoutEndpoint, window.location.origin);
    const returnToURL = new URL(window.location.href);

    if (!returnToURL.searchParams.has('anledning')) {
      returnToURL.searchParams.set('anledning', 'velkomst');
    }

    checkoutURL.searchParams.set('return_to', returnToURL.href);

    const loginEndpoint = button.dataset.subscribeLoginEndpoint;
    if (!loginEndpoint) {
      button.href = checkoutURL.href;
    } else {
      const loginURL = new URL(loginEndpoint, window.location.origin);
      loginURL.searchParams.set('return_to', `${checkoutURL.pathname}${checkoutURL.search}`);
      button.href = loginURL.href;
    }

    button.removeAttribute('aria-disabled');
    button.removeAttribute('aria-busy');
    button.querySelector('.loading__spinner').classList.add('hidden');
  };

  const updateButtons = (root = document) => {
    root.querySelectorAll('[data-subscribe-checkout-endpoint]').forEach(updateButton);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateButtons(), { once: true });
  } else {
    updateButtons();
  }

  document.addEventListener('shopify:section:load', (event) => updateButtons(event.target));
  window.addEventListener('pageshow', () => updateButtons());

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-subscribe-checkout-endpoint]');
    if (!button) return;

    if (button.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      return;
    }

    // Let new-tab/window activations leave this page's button usable.
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    button.querySelector('.loading__spinner').classList.remove('hidden');
  });
})();
